export const environment = {
  API_BASE_URL: 'https://func-guianoivas-dev-deczg2affxb9f7f7.brazilsouth-01.azurewebsites.net/api/v1',
  PUBLIC_SITE_URL: 'https://guianoivas.com',
  // Valor padrão de upgrade (em reais). Pode ser sobrescrito em ambientes via CI/CD.
  UPGRADE_PRICE: 597.00,
  INTERNAL_AUTH_EMAIL: 'jhbortol@gmail.com',
  INTERNAL_AUTH_PASSWORD: 'pesc01',
  FORNECEDOR_PUBLICADO: null as boolean | null
};
